import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { COMPANY } from "@/lib/data";

export default function ReservationPolicy() {
  return (
    <div className="min-h-screen bg-[#050505] text-white px-5 py-10">
      <div className="max-w-2xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-white/50 hover:text-[#F2B705] text-sm mb-6 transition-colors">
          <ArrowLeft size={16} /> Back to site
        </Link>
        <div className="flex items-center gap-3 mb-8">
          <img src={COMPANY.logo} alt="Auto-Hire STL" className="h-12 w-12 object-contain rounded-md" />
          <div className="font-display font-extrabold text-xl">AutoHire <span className="text-gold-gradient">STL</span></div>
        </div>
        <div data-testid="reservation-policy-page" className="bg-[#0C0C0C] border border-white/10 rounded-2xl p-7 sm:p-9">
          <div className="flex items-center gap-2 text-[#F2B705] text-sm font-bold uppercase tracking-widest mb-2">
            <ShieldCheck size={16} /> Policy v1
          </div>
          <h1 className="font-display font-black text-3xl mb-6">$20 Reservation Payment Policy</h1>
          <div className="space-y-5 text-sm text-white/75 leading-relaxed">
            <p>A $20 reservation payment is required to confirm an approved rental request. It is credited in full toward your total rental price — <b className="text-white">it is not an additional fee.</b></p>
            <div>
              <p className="text-white font-semibold mb-1">Cancellations</p>
              <p>Please contact us before your scheduled pickup time if you need to cancel. You are entitled to a refund of your $20 reservation payment, or you may ask to transfer it to a future reservation. Refunds and transfers are reviewed and handled by our team — they are never automatic.</p>
            </div>
            <div>
              <p className="text-white font-semibold mb-1">No-call / no-show</p>
              <p>If you do not contact us and do not arrive for your scheduled pickup, your $20 reservation payment is forfeited and will not be refunded. No additional charge is made beyond the $20 you already paid.</p>
            </div>
            <div>
              <p className="text-white font-semibold mb-1">If we cancel</p>
              <p>If AutoHire STL cancels your reservation or is unable to supply the vehicle, your $20 reservation payment is refundable.</p>
            </div>
            <p className="text-white/40 text-xs">No standard security deposit is collected as part of this $20 reservation payment — it is strictly a credit toward your rental total.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
